import React, { Component } from "react";
import { Select, Spin, message, Radio, Checkbox,Space } from "antd";
import Bridge from "../../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import { speech_demographics_form_type } from "../../../utils/consts";

const { Option } = Select;

export default class EthnicityRace extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      race:[],
      race_other_specification:"",

      ethnicity:"",
      ethnicity_other_specification:"",
      question_list:[],
      email:"",
      neurostamp_id:"",
      modality_id:"",
      ethnicity_list:[],
      ethnicity_of_hispanic_list:[],
      ethnicity_hispanic_input_list:[],
      ethnicity_field_array:[],
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type='+speech_demographics_form_type.ethnicity_and_race;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
        if (response.status == "1") {
          var e_list = response.field_data.ethnicity_and_race.filter(item => item.field=='DEMOG4');
          var hispanic_list = response.field_data.ethnicity_and_race.filter(item => item.field=='DEMOG41'||item.field=='DEMOG42'||item.field=='DEMOG43'||item.field=='DEMOG44');
          let ethnicity_field_array=response.field_data.ethnicity_and_race
          this.setState({
            ethnicity_list: e_list, 
            ethnicity_of_hispanic_list:hispanic_list,
            ethnicity_field_array: ethnicity_field_array,
            email:response.email,
            neurostamp_id:response.neurostamp_id,
            modality_id:response.modality_id,
          })
          let race_arr=[]
          let ethnicity_sub_list=[]
          for(let item of response.data){
            if(item.field=='DEMOG4'){
              this.setState({ethnicity: item.value})
            } 
            if (item.field == 'DEMOG571') {
              this.setState({race_other_specification: item.value})
            }
            if(item.field == 'DEMOG51' && item.value==1) {
              race_arr.push("American Indian or Alaska Native")
            }
            if (item.field == 'DEMOG52' && item.value==1) {
              race_arr.push("Asian")
            }
            if (item.field == 'DEMOG521' && item.value==1) {
              race_arr.push(". . . . . . . . . . Asian Indian")
            }
            if (item.field == 'DEMOG522' && item.value==1) {
              race_arr.push(". . . . . . . . . . Chinese")
            }
            if (item.field == 'DEMOG523' && item.value==1) {
              race_arr.push(". . . . . . . . . . Filipino")
            }
            if (item.field == 'DEMOG524' && item.value==1) {
              race_arr.push(". . . . . . . . . . Japanese")
            }
            if (item.field == 'DEMOG525' && item.value==1) {
              race_arr.push(". . . . . . . . . . Korean")
            }
            if (item.field == 'DEMOG526' && item.value==1) {
              race_arr.push(". . . . . . . . . . Vietnamese")
            }
            if (item.field == 'DEMOG527' && item.value==1) {
              race_arr.push(". . . . . . . . . . Other Asian")
            }
            if (item.field == 'DEMOG53' && item.value==1) {
              race_arr.push("Black or African American")
            }
            if (item.field == 'DEMOG54' && item.value==1) {
              race_arr.push("Native Hawaiian or Other Pacific Islander")
            }
            if (item.field == 'DEMOG55' && item.value==1) {
              race_arr.push("White")
            }
            if (item.field == 'DEMOG56' && item.value==1) {
              race_arr.push("Prefer not to answer")
            }
            if (item.field == 'DEMOG57' && item.value==1) {
              race_arr.push("Other, please specify:")
            }
           
          }
          if(race_arr.length>0){
            this.setState({race: race_arr})
          }
          for(let item of response.data){
            if(item.field=='DEMOG41' && item.value=='1'){
              ethnicity_sub_list.push('Mexican, Mexican American, Chicano/a')
            }
            if(item.field=='DEMOG42' && item.value==1){
              ethnicity_sub_list.push('Puerto Rican')
            }
            if(item.field=='DEMOG43' && item.value==1){
              ethnicity_sub_list.push('Cuban')
            }
            if(item.field=='DEMOG44' && item.value==1){
              ethnicity_sub_list.push('Another Hispanic Latino/a or Spanish origin')
            }
          }
          this.setState({ethnicity_hispanic_input_list:ethnicity_sub_list,loading:false})
          
        }else{
          this.setState({loading:false})
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  validateName = (field, label) => {
    // Check if the input contains only alphabetic characters
    // if (!/^[A-Za-z]+$/.test(field)) {
    //   // message.warning(`${label} can only contain alphabetic characters.`);
    //   return `${label} can only contain alphabetic characters.`;
    // }
    // Check if the length of the input is within a specific range
    if (field.length <= 2 || field.length > 30) {
      // message.warning(`${label} must be between 2 and 30 characters long.`);
      return `${label} must be between 2 and 30 characters long.`;
    }
    return 1;
  };
  onChangeRace = (e) => {
    let value = e.target.value;
    if(value=='Prefer not to answer' && e.target.checked==true){
      this.setState({ race: [value],race_other_specification: "" });
      return
    }
    let tempArr = this.state.race;
    if (!tempArr.includes("Asian")) {
      tempArr = tempArr.filter((item) => item != ". . . . . . . . . . Asian Indian");
      tempArr = tempArr.filter((item) => item != ". . . . . . . . . . Chinese");
      tempArr = tempArr.filter((item) => item != ". . . . . . . . . . Filipino");
      tempArr = tempArr.filter((item) => item != ". . . . . . . . . . Japanese");
      tempArr = tempArr.filter((item) => item != ". . . . . . . . . . Korean");
      tempArr = tempArr.filter((item) => item != ". . . . . . . . . . Vietnamese");
      tempArr = tempArr.filter((item) => item != ". . . . . . . . . . Other Asian");
    }
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      if (!newArray.includes("Other, please specify:")) {
        this.setState({ race_other_specification: "" });
      }
      this.setState({ race: newArray });
    } else {
      tempArr.push(value);
      if (!tempArr.includes("Other, please specify:")) {
        this.setState({ race_other_specification: "" });
      }
      this.setState({ race: tempArr });
    }
  };
  // step 1
  save_details = () => {
    if (this.state.race.includes("Other, please specify:")==true &&
     !this.state.race_other_specification 
    ) { 
      message.warning("Please enter race field specification.");
      return;
    }
    if (!this.state.ethnicity) {
      message.warning("Please select ethnicity option");
      return;
    }
    let array=this.state.ethnicity_field_array
    let new_arr=[];
    for(let item of array){
      if(item.field=='DEMOG4'){
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.ethnicity,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      } 
      // American Indian or Alaska Native
      if(item.field == 'DEMOG51') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('American Indian or Alaska Native')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // Asian
      if (item.field === 'DEMOG52') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('Asian')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // . . . . . . . . . . Asian Indian
      if (item.field == 'DEMOG521') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('. . . . . . . . . . Asian Indian')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // . . . . . . . . . . Chinese
      if (item.field == 'DEMOG522') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('. . . . . . . . . . Chinese')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // . . . . . . . . . . Filipino
      if (item.field == 'DEMOG523') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('. . . . . . . . . . Filipino')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // . . . . . . . . . . Japanese
      if (item.field == 'DEMOG524') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('. . . . . . . . . . Japanese')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // . . . . . . . . . . Korean
      if (item.field == 'DEMOG525') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('. . . . . . . . . . Korean')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // . . . . . . . . . . Vietnamese
      if (item.field == 'DEMOG526') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('. . . . . . . . . . Vietnamese')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // Other Asian
      if (item.field == 'DEMOG527') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('. . . . . . . . . . Other Asian')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // Black or African American
      if (item.field == 'DEMOG53') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('Black or African American')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // Native Hawaiian or Other Pacific Islander
      if (item.field == 'DEMOG54') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('Native Hawaiian or Other Pacific Islander')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // White
      if (item.field == 'DEMOG55') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('White')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // Prefer not to answer
      if (item.field == 'DEMOG56') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value: this.state.race.includes('Prefer not to answer')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      // Other, please specify:
      if (item.field == 'DEMOG57') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race.includes('Other, please specify:')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      if (item.field == 'DEMOG571') {
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.race_other_specification,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      if(item.field=='DEMOG41'){
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.ethnicity_hispanic_input_list.includes('Mexican, Mexican American, Chicano/a')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      if(item.field=='DEMOG42'){
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.ethnicity_hispanic_input_list.includes('Puerto Rican')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      if(item.field=='DEMOG43'){
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.ethnicity_hispanic_input_list.includes('Cuban')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }
      if(item.field=='DEMOG44'){
        let obj={
          email:this.state.email,
          neurostamp_id:this.state.neurostamp_id,
          modality_uid:this.state.modality_id,
          value:this.state.ethnicity_hispanic_input_list.includes('Another Hispanic Latino/a or Spanish origin')?1:0,
          view_name:item.view_name,
          form:'Ethnicity and Race',
          field: item.field
        }
        new_arr.push(obj)
      }

    }
    let params = {
      data: JSON.stringify(new_arr),
      step: speech_demographics_form_type.ethnicity_and_race,
      action_type: this.props.is_update == true ? "update" : "insert",
      email:this.state.email,
      neurostamp_id:this.state.neurostamp_id,
      modality_id:this.state.modality_id,
    };
    this.setState({ loading: true });
    Bridge.demographics.speech
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(4);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeEthnicityHispanic = (e) => {
    let value = e.target.value;
    if(value=='Prefer not to answer'){
      this.setState({ ethnicity_hispanic_input_list: [] });
      return
    }
    let tempArr = this.state.ethnicity_hispanic_input_list;
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ ethnicity_hispanic_input_list: newArray });
    } else {
      tempArr.push(value);
      this.setState({ ethnicity_hispanic_input_list: tempArr });
    }
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Ethnicity and Race</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
              Which category or categories best describe your race? Select all that apply.
              </label>
              <ul>
                <li>
                  <Checkbox
                    value={"American Indian or Alaska Native"}
                    onChange={this.onChangeRace}
                    checked={
                      this.state.race.includes(
                        "American Indian or Alaska Native"
                      )
                        ? true
                        : false
                    }
                    disabled={this.state.race.includes("Prefer not to answer")? true :false}
                  >
                    American Indian or Alaska Native
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"Asian"}
                    onChange={this.onChangeRace}
                    checked={this.state.race.includes("Asian") ? true : false}
                    disabled={this.state.race.includes("Prefer not to answer")? true :false}
                  >
                    Asian
                  </Checkbox>
                </li>
                {this.state.race.includes("Asian") && (
                  <div>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes(". . . . . . . . . . Asian Indian")
                            ? true
                            : false
                        }
                        disabled={this.state.race.includes("Prefer not to answer")? true :false}
                        value={". . . . . . . . . . Asian Indian"}
                        onChange={this.onChangeRace}
                      >
                        . . . . . . . . . . Asian Indian
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes(". . . . . . . . . . Chinese") ? true : false
                        }
                        value={". . . . . . . . . . Chinese"}
                        disabled={this.state.race.includes("Prefer not to answer")? true :false}
                        onChange={this.onChangeRace}
                      >
                        . . . . . . . . . . Chinese
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes(". . . . . . . . . . Filipino") ? true : false
                        }
                        value={". . . . . . . . . . Filipino"}
                        disabled={this.state.race.includes("Prefer not to answer")? true :false}
                        onChange={this.onChangeRace}
                      >
                        . . . . . . . . . . Filipino
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes(". . . . . . . . . . Japanese") ? true : false
                        }
                        value={". . . . . . . . . . Japanese"}
                        disabled={this.state.race.includes("Prefer not to answer")? true :false}
                        onChange={this.onChangeRace}
                      >
                        . . . . . . . . . . Japanese
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes(". . . . . . . . . . Korean") ? true : false
                        }
                        value={". . . . . . . . . . Korean"}
                        disabled={this.state.race.includes("Prefer not to answer")? true :false}
                        onChange={this.onChangeRace}
                      >
                        . . . . . . . . . . Korean
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes(". . . . . . . . . . Vietnamese") ? true : false
                        }
                        value={". . . . . . . . . . Vietnamese"}
                        disabled={this.state.race.includes("Prefer not to answer")? true :false}
                        onChange={this.onChangeRace}
                      >
                        . . . . . . . . . . Vietnamese
                      </Checkbox>
                    </li>
                    <li>
                      <Checkbox
                        checked={
                          this.state.race.includes(". . . . . . . . . . Other Asian") ? true : false
                        }
                        value={". . . . . . . . . . Other Asian"}
                        disabled={this.state.race.includes("Prefer not to answer")? true :false}
                        onChange={this.onChangeRace}
                      >
                        . . . . . . . . . . Other Asian
                      </Checkbox>
                    </li>
                  </div>
                )}
                <li>
                  <Checkbox
                    value={"Black or African American"}
                    checked={
                      this.state.race.includes("Black or African American")
                        ? true
                        : false
                    }
                    disabled={this.state.race.includes("Prefer not to answer")? true :false}
                    onChange={this.onChangeRace}
                  >
                    Black or African American
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"Native Hawaiian or Other Pacific Islander"}
                    onChange={this.onChangeRace}
                    checked={
                      this.state.race.includes(
                        "Native Hawaiian or Other Pacific Islander"
                      )
                        ? true
                        : false
                    }
                    disabled={this.state.race.includes("Prefer not to answer")? true :false}
                  >
                    Native Hawaiian or Other Pacific Islander
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.race.includes("White") ? true : false}
                    value={"White"}
                    disabled={this.state.race.includes("Prefer not to answer")? true :false}
                    onChange={this.onChangeRace}
                  >
                    White
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={this.state.race.includes("Other, please specify:") ? true : false}
                    value={"Other, please specify:"}
                    disabled={this.state.race.includes("Prefer not to answer")? true :false}
                    onChange={this.onChangeRace}
                  >
                    Other, please specify:
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={
                      this.state.race.includes("Prefer not to answer")
                        ? true
                        : false
                    }
                    value={"Prefer not to answer"}
                    onChange={this.onChangeRace}
                  >
                    Prefer not to answer
                  </Checkbox>
                </li>
              </ul>
            </div>
            {this.state.race.includes("Other, please specify:") && (
              <div className="form-group">
                <label className="input-heading">
                  Specification 
                </label>
                <br />
                <input
                  type={"text"}
                  value={this.state.race_other_specification}
                  onChange={(e) =>{
                    this.setState({ race_other_specification: e.target.value })
                    }
                  }
                  placeholder="Race, other"
                />
              </div>
            )}
            <div className="form-group">
              <label className="input-heading">
              Please, select your ethnicity <span className="text-danger">*</span>
              </label>
              <ul>
                <li>
                  <Radio.Group
                    onChange={(e)=>{
                      this.setState({
                        ethnicity:e.target.value,
                        ethnicity_hispanic_input_list:[]
                      })
                    }}
                    value={this.state.ethnicity}
                    direction="vertical"
                  >
                    <Space direction="vertical">
                    {this.state.ethnicity_list.map((item,index)=>{
                      return (
                      <Radio value={item.values}>{item.description}</Radio>
                      )
                    })}
                    </Space>
                  </Radio.Group>
                </li>
                {this.state.ethnicity==1 && (
                  <div className="pt-3">
                   {this.state.ethnicity_of_hispanic_list.map((item,index)=>{       
                      return (
                      <li key={index}>
                        <Checkbox
                          value={item.field_description}
                          onChange={this.onChangeEthnicityHispanic}
                          checked={
                            this.state.ethnicity_hispanic_input_list.includes(item.field_description)
                              ? true
                              : false
                          }
                        >
                          {item.field_description}
                        </Checkbox>
                      </li>
                       )
                    })}
                  </div>
                )}
              </ul>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(2)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
